export default __webpack_public_path__ + "static/media/Logo Final.7b8d1ee0.png";